
var anchors = [];

export function closeAllFormulaTips() {
  anchors.forEach(function (vm) {
    vm.forceClose();
  });
}

function closeOthers(self) {
  anchors.forEach(function (vm) {
    if (vm !== self) vm.forceClose();
  });
}

export default {
  name: 'formula-tip',
  props: {
    text: { type: String, default: '' },
    labelClass: { type: String, default: '' },
    block: { type: Boolean, default: false }
  },
  data: function () {
    return {
      open: false,
      timer: null
    };
  },
  watch: {
    text: function (value) {
      if (!value) this.forceClose();
    }
  },
  created: function () {
    anchors.push(this);
  },
  beforeDestroy: function () {
    this.forceClose();
    var i = anchors.indexOf(this);
    if (i >= 0) anchors.splice(i, 1);
  },
  methods: {
    onEnter: function () {
      this.hold();
      if (!this.text) {
        this.open = false;
        return;
      }
      closeOthers(this);
      this.open = true;
    },
    hold: function () {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    scheduleClose: function () {
      var t = this;
      this.hold();
      this.timer = setTimeout(function () {
        t.timer = null;
        t.open = false;
      }, 160);
    },
    forceClose: function () {
      this.hold();
      this.open = false;
    }
  }
};
